import { FC, useState } from 'react'
import { HexColorPicker } from 'react-colorful'
import { DEFAULT_COLOR_PICKER } from 'constant'

import { Button, Input } from 'ui'
import { useTranslation } from 'react-i18next'

type ColorPickerProps = {
  handleColorChange: (value: string) => void
  initialColor: string
}

const ColorPicker: FC<ColorPickerProps> = ({ handleColorChange, initialColor }) => {
  const { t } = useTranslation('legacy')

  const [color, setColor] = useState(initialColor ?? DEFAULT_COLOR_PICKER)

  const processInput = (color: string) => {
    const trimmedColor = color.trim()
    const startedWithHash = trimmedColor.startsWith('#')
    const processedColor = startedWithHash ? trimmedColor : `#${trimmedColor}`
    const maxInputLength = startedWithHash ? 7 : 6

    if (processedColor.length > maxInputLength) return DEFAULT_COLOR_PICKER
    return processedColor
  }

  return (
    <div className="form-group">
      <label>{t('COLOR')}</label>
      <HexColorPicker
        color={color}
        onChange={value => {
          setColor(value)
          handleColorChange(value)
        }}
        className="m-x-4"
      />
      <div className="d-flex my-2 input-group">
        <Input
          value={color}
          onChange={e => {
            const value = processInput(e.target.value)
            setColor(value)
            handleColorChange(value)
          }}
        />
        <div className="input-group-append">
          <Button
            color="secondary"
            outlined
            size="small"
            onClick={() => {
              setColor(DEFAULT_COLOR_PICKER)
              handleColorChange(DEFAULT_COLOR_PICKER)
            }}
            type="button"
          >
            <i className="fa-solid fa-trash"></i>
          </Button>
        </div>
      </div>
    </div>
  )
}

export { ColorPicker }
